import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IPMYTValidationState,
  TOptionalCheck,
} from 'src/manageAction/interfaces/ManageActionValidationSlices';

const initialState: IPMYTValidationState = {
  optionalCheck: {},
  isPMYTValidationNeeded: true,
  PMYTValidationNeeded: true,
  disableDealDetails: true,
  disablePartnerDetails: true,
  isDoneStatusValid: true,
};

export const PMYTValidationSlice = createSlice({
  name: 'PMYTValidationSlice',
  initialState,
  reducers: {
    //use below action to update more state of the cosell validation
    updatePMYTValidation: (state, action: PayloadAction<IPMYTValidationState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateOptionalCheck: (state, action: PayloadAction<TOptionalCheck>) => {
      state.optionalCheck = action.payload;
    },
    updateisPMYTValidationNeeded: (state, action: PayloadAction<boolean>) => {
      state.isPMYTValidationNeeded = action.payload;
    },
    ValidationNeeded: (state, action: PayloadAction<boolean>) => {
      state.isPMYTValidationNeeded = action.payload;
    },
    updateDisableDealDetails: (state, action: PayloadAction<boolean>) => {
      state.disableDealDetails = action.payload;
    },
    updateDisablePartnerDetails: (state, action: PayloadAction<boolean>) => {
      state.disablePartnerDetails = action.payload;
    },
    updateIsDoneStatusValid: (state, action: PayloadAction<boolean>) => {
      state.isDoneStatusValid = action.payload;
    },
  },
});
export default PMYTValidationSlice.reducer;
export const {
  updatePMYTValidation,
  updateisPMYTValidationNeeded,
  ValidationNeeded,
  updateOptionalCheck,
  updateDisableDealDetails,
  updateDisablePartnerDetails,
  updateIsDoneStatusValid,
} = PMYTValidationSlice.actions;
